import { RefObject, useLayoutEffect, useState } from 'react'
export const useIsOverflown = (ref: RefObject<HTMLElement>) => {
  const [isOverflown, setIsOverflown] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    const handleResize = () => {
      setIsOverflown(element.scrollWidth > element.clientWidth)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [ref])

  return isOverflown
}
